import React from 'react';
import Image from 'next/image';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

const FeaturesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {/* Protection Section */}
      <section className={styles.impersonation}>
        <h2
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: t('Why Combat Digital Impersonation?', { impersonation: t('Impersonation') }),
          }}
        />
        <p className={styles.impersonationDesc}>
          {t(
            'Digital Imitation verwäscht die Vertrauen, das deine Kunden in dich setzen – sowohl jetzt als auch in Zukunft. Wenn jemand dich oder deine Marke imitieren kann, kann er falsche Informationen verbreiten und deine öffentliche Bildung beschädigen.',
          )}
        </p>
        <p className={styles.impersonationDesc}>
          {t(
            `That’s why it's crucial to prevent impersonation, maintain trust, and keep control of your brand's reputation.`,
          )}
        </p>
      </section>
      {/* Protection Section */}
      <section className={styles.section}>
        <div className={styles.content}>
          <h2 className={styles.title}>{t('Stop Losing Your Identity and Income to Impersonation')}</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('Impersonation Removal')}</span>
                    <span className={styles.itemDescription}>
                      {t('is essential to protect your brand, reputation, and customer trust.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span className={styles.itemDescription}>
                    {t(
                      'Cybercriminals and fraudsters create fake accounts, websites, or profiles that mimic your brand, mislead your customers, and cause significant harm.',
                    )}
                  </span>
                </h3>
              </div>
            </li>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('Prevent Brand Misuse')}</span>
                    <span className={styles.itemDescription}>
                      {t('and ensure your customers engage only with genuine, trusted sources.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
          </ul>
        </div>
        <div className={styles.imageWrapper}>
          <Image
            src={`https://res-front.pumpsoul.com/prod-erasa/image/remove-fake-account/onlyfans-features-2-icon.webp`}
            alt="Erasa Protection"
            width={400}
            height={400}
            layout="responsive"
            loading="lazy"
            className={styles.image}
          />
        </div>
      </section>
      {/* Risks Section */}
      <section className={styles.section}>
        <div className={styles.content}>
          <h2 className={styles.title}>{t('How Erasa’s Impersonation Removal Works')}</h2>
          <p className={styles.subtitle}>
            {t('Did You Know? Cybercriminals are exploiting vulnerabilities faster than ever.')}
          </p>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('24/7 AI Monitoring')}:</span>
                    <span className={styles.itemDescription}>
                      {t('Continuous scans to detect and flag fake accounts.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('Automated Takedown')}:</span>
                    <span className={styles.itemDescription}>
                      {t('Fake accounts are identified and removed automatically.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('Platform Collaboration')}:</span>
                    <span className={styles.itemDescription}>
                      {t('We work with platforms to ensure quick account removal.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('Real-Time Reports')}:</span>
                    <span className={styles.itemDescription}>
                      {t('Get immediate updates and detailed weekly reports.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
            <li className={styles.listItem}>
              <div>
                <h3 className={styles.itemTitle}>
                  <span className={styles.ulDot}>•</span>
                  <span>
                    <span className={styles.itemDescriptionWeight}>{t('Expert Support')}:</span>
                    <span className={styles.itemDescription}>
                      {t('Erasa ensure no impersonation goes unchecked.')}
                    </span>
                  </span>
                </h3>
              </div>
            </li>
          </ul>
        </div>
        <div className={styles.imageWrapper}>
          <Image
            src={`https://res-front.pumpsoul.com/prod-erasa/image/remove-fake-account/onlyfans-features-1-icon.webp`}
            alt="Risks of Impersonation"
            width={400}
            height={400}
            layout="responsive"
            loading="lazy"
            className={styles.image}
          />
        </div>
      </section>
    </div>
  );
};

export default FeaturesSection;
